var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222A30;}\n\t.st1{fill:#868687;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#222A30;stroke:#222A30;stroke-width:0.776;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222A30;fill-opacity:0;stroke:#222A30;stroke-width:0.776;}\n\t.st4{fill:none;stroke:#222A30;stroke-width:1.5556;stroke-opacity:0.5;}\n\t.st5{fill:none;stroke:#222A30;stroke-width:1.5556;}\n\t.st6{fill:#070707;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,25.9L29.9,7.9c0-0.6-0.5-1-1-1L16.1,7c-0.4,0-0.7-0.7-0.7-1l0-0.1  c0-0.6-0.5-1.1-1.1-1.1L7.5,4.9C7,4.9,6.5,5.3,6.5,5.9l0,0.1c0,0.3-0.3,1-0.7,1l0,0c-0.5,0-1,0.5-1,1l0,5.2l-2.2,0c0,0-1,0-0.6,1.1  l2.4,11.7c0,0.6,0.4,1.1,1,1.1l24-0.2C30.1,27,30,25.9,30,25.9z M28.7,14.6l0.1,11.8l-2.4-12.6c-0.2-0.7-1-0.6-1-0.6L6.1,13.3l0-4  l22.6-0.2L28.7,14.6L28.7,14.6z",
    id: "file_x5F_folder"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.bdeb6754548662cae21ede32fc2858a2.svg";
export { ForwardRef as ReactComponent };